export const setUserToken = token => ({ type: 'SET_USER_TOKEN', payload: token })
export const setUserInfos = infos => ({ type: 'SET_USER_INFOS', playload: infos })
export const setUserAccess = access => ({ type: 'SET_USER_ACCESS', payload: access })
export const setUserAlert = alert => ({ type: 'SET_USER_ALERT', payload: alert })
export const logOut = () => ({ type: 'LOGOUT' })